'use client'

import {Alert} from 'antd'
import {observer} from 'mobx-react'

import {Routes} from '@/src/config/routes'

import {ArticlesListContent} from '@/src/features/news-articles'
import {NewsPagination} from '@/src/features/news-articles/pagination'

import {useStore} from '@/src/shared/hooks/useStore'
import {sanitizeHtml} from '@/src/shared/utils/functions'

import * as UI from './screen.styled'
import {PageData} from '@/src/core/domain/entities/page/page-data'

export const ArticlesScreen: React.FC<PageData<ArticlesListContent>> = observer(() => {
  const {pageData} = useStore<ArticlesListContent>()
  const content = pageData!.content

  const {articles, rubrics, rubric: activeRubric} = content

  return (
    <UI.Wrapper>
      <UI.Top>
        <UI.Tags>
          <UI.Tag $active={!activeRubric}>
            <UI.TagLink href={Routes.articles.page}>Все</UI.TagLink>
          </UI.Tag>

          {rubrics.map(rubric => (
            <UI.Tag key={rubric.id} $active={rubric.id === activeRubric?.id}>
              <UI.TagLink href={Routes.articles.section.page(rubric.path)}>
                {rubric.name}
              </UI.TagLink>
            </UI.Tag>
          ))}
        </UI.Tags>

        {content.articles.pages > 1 && <NewsPagination />}
      </UI.Top>

      <UI.Articles>
        {(articles.items.length > 0 &&
          articles.items.map(article => (
            <UI.ArticleContainer key={article.code}>
              <UI.NewsTile
                article={article}
                href={Routes.articles.article.page(article.code)}
                showTitle={false}
                datePlacement="left"
              />
              <UI.ArticleContent>
                <UI.NewsTileTitle href={Routes.articles.article.page(article.code)}>
                  {article.title}
                </UI.NewsTileTitle>
                <UI.NewsTileDescription
                  dangerouslySetInnerHTML={{__html: sanitizeHtml(article.preview?.text)}}
                />
              </UI.ArticleContent>
            </UI.ArticleContainer>
          ))) || <UI.Alert as={Alert} description="Нет статей" />}
      </UI.Articles>

      {content.articles.pages > 1 && <NewsPagination />}
    </UI.Wrapper>
  )
})
